import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

const vuetify = new Vuetify({
  theme: {
    dark: true,
    themes: {
      dark: {
        primary: '#E1D7C4',
        secondary: '#005A55',
        accent: '#E1D7C4',
        anchor: '#E1D7C4',
        error: '#DC4F4B',
        info: '#FFFFFF',
        success: '#87B0B1',
        warning: '#B12823',
        background: '#005A55',
      },
    },
  },
})

export default vuetify;
